<davinci-button (click)="downloadManifests()">{{ 'admin.download' | translate }}</davinci-button>
